@use "../../../../globals/bcp-2022/objects/button-badge";
@use "../../../../globals/bcp";

.f-profile-flyout {
  &__username {
    @include bcp.text-overflow(1);
    display: inline-block;
    max-width: bcp.size(200);
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
